export function getCustomerApiErrorMessage({ status = 0, data = {}, fallbackMessage = "" } = {}) {
  const technicalMessage = String(data.error || data.message || "");
  const normalized = technicalMessage.toLowerCase();

  if (status === 401) return "Your session expired. Please sign in again.";
  if (status === 403) return "You don't have permission to perform this action.";
  if ((status === 409 || normalized.includes("already exists")) && normalized.includes("campaign")) {
    return "That campaign designator is already in use. Choose another one.";
  }
  if ((status === 409 || normalized.includes("already exists")) && normalized.includes("email")) {
    return "That email address is already registered.";
  }
  if (status === 409 || normalized.includes("already exists")) return "That record already exists.";
  if (status === 429) return "Cologuard is busy right now. Please wait a moment and try again.";
  if (status >= 500) return "We couldn't complete this action. Please try again.";

  if (normalized.includes("campaign not found")) return "This campaign could not be found.";
  if (normalized.includes("missing required") || normalized.includes("must be")) {
    return "Some campaign information is invalid. Review the form and try again.";
  }

  return fallbackMessage || "We couldn't complete this action. Please try again.";
}

export function getCampaignSuccessMessage(action) {
  if (action === "generation_already_complete") return "The campaign codes are already ready.";
  if (action === "retried_incomplete_batches") return "Code preparation has restarted.";
  return "Campaign created. Code preparation has started.";
}

export function getCustomerAuthErrorMessage(error) {
  return error ? "We couldn't sign you in. Please try again." : "";
}
